import Swal from "sweetalert2";
import faradayApi from "../../../api/faradayApi";

export const fetchData = async (setList, url, t) => {
  try {
    const { data } = await faradayApi.get(url);
    setList(data.data);
  } catch (error) {
    console.log(error);
    setList([]);
    Swal.fire({
      confirmButtonColor: "#001B60",
      text: t("error.errorMsg"),
      icon: "error",
    });
  }
};

export const fetchDataValuationStartup = async (url, t) => {
  try {
    const { data } = await faradayApi.get(url);
    return data.data;
  } catch (error) {
    console.log(error);
    await Swal.fire({
      confirmButtonColor: "#001B60",
      text: "No hay ninguna valoración de la startup con está fecha, cambie la fecha por una valida o agregue nueva valoración de startup", //t("error.errorMsg")
      icon: "error",
    });
    return false;
  }
};
